/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'

function Template() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='col-12 text-center'>
					<h2>The Etho Ethical Production Standards</h2>
				</div>
			</Section>

			<Section id='production-standard__section'>
				<div className='col-12'>
					<p>
						It is important that our sellers value our 7 Core
						Principles of Ethical Production:
					</p>
					<ol>
						<li>
							<span className='semi-bold'>Opportunity:</span>
							Market Access and Economic Integration: The Etho
							provides marginalized communities with access to the
							global market. The sale of Fair Trade and ethically
							produced products gives stakeholders the profit and
							resources needed to lift themselves out of poverty.
						</li>
						<li>
							<span className='semi-bold'>Transparency:</span>
							We require transparency in the social and
							environmental aspects of our sellers' production.
						</li>
						<li>
							<span className='semi-bold'>
								Non-exploitative Trade Relationships and Wages:
							</span>
							Every individual in the supply chain is treated with
							respect and ensured a wage at or above local
							standards.
						</li>
						<li>
							<span className='semi-bold'>
								Labor Conditions &amp; Restrictions:
							</span>
							The Etho prohibits the use of child labor, forced
							labor, or unsafe working conditions in the
							production facilities used by any of our sellers.
						</li>
						<li>
							<span className='semi-bold'>
								Women's Economic Empowerment &amp; Freedom of
								Association:
							</span>
							We value female-operated enterprises that support
							women's economic empowerment, gender equality, and
							community building.
						</li>
						<li>
							<span className='semi-bold'>
								Skill-set Building &amp; Opportunity
								Infrastructure:
							</span>
							Our partners do more than offer employment. They
							give valuable assets to workers through training and
							education.
						</li>
						<li>
							<span className='semi-bold'>
								Environmental Sustainability:
							</span>
							Production practices should have a minimal or offset
							impact on the environment.
						</li>
					</ol>
				</div>
			</Section>

			<Section id='standards-table__section'>
				<table>
					<thead>
						<tr>
							<th>Production Principle</th>
							<th>Production Standard</th>
							<th>Seller Recommendations</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>
								Opportunity: Market Access &amp; Economic
								Integration
							</th>
							<th>
								Sales should provide fair income for
								stakeholders and provide resources to avoid or
								overcome poverty and plan for a sustainable
								future.
							</th>
							<th>
								The business relationship with
								suppliers/producers must be based on respect,
								opennes and negotiation, keeping in mind the aim
								to poverty reduction and support to marginal
								producers
							</th>
						</tr>
						<tr>
							<th>Transparency</th>
							<th>
								Our sellers provide us with information on their
								supply chain and production practices.
							</th>
							<th>
								Sellers should visit the producers in their
								supply chain to discuss social and environmental
								practices with management.
							</th>
						</tr>
						<tr>
							<th>
								Non-Exploitative Trade Relationships &amp; Wages
							</th>
							<th>
								Sellers should be aware of regional minimum
								wages and their adequacy to cover local minimum
								wage.
							</th>
							<th>
								Sellers should work on a time-bound plan to pay
								a living wage to all employees by utilizing
								resources provided by the World Etho Trade
								Organization and Global Living Wage Coalition.
							</th>
						</tr>
						<tr>
							<th>Labor Conditions &amp; Restrictions</th>
							<th>
								Sellers must provide a safe environment and fair
								compensation for workers. We prohibit child and
								forced labor in factories of our sellers or
								seller's partners.
							</th>
							<th>
								Can be best verified by visiting the production
								units in supply chain, interviewing the workers,
								and building long-lasting relationships, based
								on trust, with them.
							</th>
						</tr>
						<tr>
							<th>
								Women's Economic Empowerment &amp; Freedom of
								Association
							</th>
							<th>
								Workers shall not face gender-based
								discrimination in the workplace, and have the
								right to join labor unions or workers'
								committees.
							</th>
							<th>
								Can be best verified by visiting the production
								units in supply chain, interviewing the workers,
								and building long-lasting relationships, based
								on trust, with them.
							</th>
						</tr>
						<tr>
							<th>
								Skill-set Building &amp; Opportunity
								Infrastructure
							</th>
							<th>
								Sellers and producers should provide proper
								skill-training to employees
							</th>
							<th>
								Sellers should make intentional efforts to
								upgrade workers' skills and capacities for
								upward mobility.
							</th>
						</tr>
						<tr>
							<th>Environmental Sustainability</th>
							<th>
								Production practices and inputs--such as
								chemicals, dyes, and waste waters--should have
								as low of an impact on the environment as
								possible.
							</th>
							<th>
								Sellers should take responsibility for origin of
								raw materials and shift to organic and
								eco-friendly inputs.
							</th>
						</tr>
					</tbody>
				</table>
			</Section>
		</div>
	)
}

export default Template
